import { Store } from "@/App/store";
import { HttpEngine } from "@/App/services/HttpEngine";

export const post = (path: string, request?: any, queryParams?: any): Promise<any> => {
  return HttpEngine.post(path, request, { params: queryParams }).then(extractData).catch(handleResponseError);
};

export const get = (path: string): Promise<any> => {
  return HttpEngine.get(path).then(extractData).catch(handleResponseError);
};

export const put = (path: string, request: any): Promise<any> => {
  return HttpEngine.put(path, request).catch(handleResponseError);
};

export const patch = (path: string, request: any = {}): Promise<any> => {
  return HttpEngine.patch(path, request).then(extractData).catch(handleResponseError);
};

export const del = (path: string, queryParams?: any): Promise<any> => {
  return HttpEngine.delete(path, { params: queryParams }).then(extractData).catch(handleResponseError);
};

const extractData = ({ data }) => data;

function handleResponseError(error: any) {
  Store.dispatch("Global/doneLoading");

  const errorHandlers: any = {
    401: () => {
      Store.dispatch("Login/validateToken", true);
    },
    default: () => {
      Store.dispatch("Error/setError", "Error processing request.");
      throw error;
    },
  };
  const handler = errorHandlers[error.response?.status] || errorHandlers["default"];
  handler();
}

export const HttpClient = {
  get,
  post,
  put,
  patch,
  delete: del,
};
